// Localised record label (reimbursement groups come from the server as "N expenses").
export const recLabel = (x, t) => {
  const m = /^(\d+) expenses$/.exec(x?.label || '');
  return m ? t('bank.nExpenses', { count: Number(m[1]) }) : (x?.label || '—');
};
